module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("TABLE OF CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "href": "#/08_ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/09_intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a"
  }, [_c('a', {
    attrs: {
      "href": "#/10_ch1"
    }
  }, [_c('b', [_vm._v("1")]), _vm._v("    Value Your Time")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/11_ch2"
    }
  }, [_c('b', [_vm._v("2")]), _vm._v("    Get Paid for Your Information")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/12_ch3"
    }
  }, [_c('b', [_vm._v("3")]), _vm._v("    Is the Customer Always Right?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/13_ch4"
    }
  }, [_c('b', [_vm._v("4")]), _vm._v("    Evaluating Customer Complaints")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/14_ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5")]), _vm._v("    How to Dress for Success: the Lost Skeleton of Cadavra")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/15_ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6")]), _vm._v("    Seven Steps to Outrageous Business Success")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7")]), _vm._v("    The Trouble With Asking Strangers for Favors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/17_ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8")]), _vm._v("    Do C-Level Executives Speak a Different Language")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/18_ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("9")]), _vm._v("    Asking People for Free Advice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/19_ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("10")]), _vm._v("  Find a Need and Fill It")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/20_ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("11")]), _vm._v("  Are You a Type A or Type B Personality?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/21_ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("12")]), _vm._v("  Three Ways to Win at E-Mail Marketing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/22_ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("13")]), _vm._v("  What’s Working in Direct Mail Today")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/23_ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("14")]), _vm._v("  Biggest Self-Help Myth Exposed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/24_ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("15")]), _vm._v("  Fail Your Way to Success")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/25_ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("16")]), _vm._v("  Write Like Your Reader Talks")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/26_ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("17")]), _vm._v("  The Time for Action is Now")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/27_ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("18")]), _vm._v("  Make Yourself Indispensable")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/28_ch19",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("19")]), _vm._v("  Have an Attitude of Gratitude")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/29_ch20",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("20")]), _vm._v("  Keep Your PC Running in Any Situation")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/30_ch21",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("21")]), _vm._v("  Stop Bragging")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/31_ch22",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("22")]), _vm._v("  Stick to Your Niche")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/32_ch23",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("23")]), _vm._v("  Twenty One Things That are Wrong About Modern Marketing")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/33_ch24",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("24")]), _vm._v("  Do What Makes You Happy")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/34_ch25",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("25")]), _vm._v("  How to Get People to Trust You")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/35_ch26",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("26")]), _vm._v("  Why Information Products are Like Fruit")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/36_ch27",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("27")]), _vm._v("  Should Your Worry About Internet Piracy?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/37_ch28",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("28")]), _vm._v("  Best Places to Get Sales Leads")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/38_ch29",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("29")]), _vm._v("  Let Go of the Past")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/39_ch30",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("30")]), _vm._v("  How to Write Great How-to Content")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/40_ch31",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("31")]), _vm._v("  Become a More Confident Speaker")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/41_ch32",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("32")]), _vm._v("  The Four Stages of Marketing Competence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/42_ch33",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("33")]), _vm._v("  Twenty Two Undeniable Truths of Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/43_ch34",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("34")]), _vm._v("  Start Small")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/44_ch35",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("35")]), _vm._v("  Thirty Eight Great Headlines You Can Swipe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/45_ch36",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("36")]), _vm._v("  Seven Ways to Command Higher Fees")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/46_ch37",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("37")]), _vm._v("  Command Premium Pricing for Your Products")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/47_ch38",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("38")]), _vm._v("  Write Stronger Landing Pages")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/48_ch39",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("39")]), _vm._v("  Ten Steps to Internet Marketing Success")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/49_ch40",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("40")]), _vm._v("  Selling with “False Logic”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/50_ch41",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("41")]), _vm._v(" The Awful Truth About Affiliate Marketing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/51_ch42",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("42")]), _vm._v("  Thank a Teacher Today")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/52_ch43",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("43")]), _vm._v("  Do You Really Need to Ask?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/53_ch44",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("44")]), _vm._v("  Start Your Own Home Business After")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/54_ch45",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("45")]), _vm._v("  The 4 Keys to Success and Happiness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/55_ch46",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("46")]), _vm._v("  Five ways to take the fear and anxiety out of 121 public speaking")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/56_ch47",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("47")]), _vm._v("  New Google algorithm demands better article writing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/57_ch48",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("48")]), _vm._v("  Service businesses: 7 ways to beat your competitors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/58_ch49",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("49")]), _vm._v("  Is your music still inside you?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/59_ch50",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("50")]), _vm._v("  Marketing with premiums")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/60_ch51",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("51")]), _vm._v("  Work is its own reward")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/61_ch52",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("52")]), _vm._v("  What I love about copywriting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/62_ch53",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("53")]), _vm._v("  How to get really good at writing or anything else")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/63_ch54",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("54")]), _vm._v("  Keep your PC up and running — all the time")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/64_ch55",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("55")]), _vm._v("  Common grammar mistakes to avoid")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/65_ch56",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("56")]), _vm._v("  Who buys information products?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/66_ch57",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("57")]), _vm._v("  The power of persistence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/67_ch58",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("58")]), _vm._v("  The hidden dangers of a 9 to 5 job")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/68_ch59",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("59")]), _vm._v("  Three reasons why people don’t write well")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/69_ch60",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("60")]), _vm._v("  Don’t get enamored with what’s hot and trendy in marketing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/70_ch61",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("61")]), _vm._v("  Improve Personal Productivity with the Pareto Principle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/71_ch62",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("62")]), _vm._v("  Why Internet marketers give away their content for free")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/72_ch63",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("63")]), _vm._v("  What’s your definition of success?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/73_ch64",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("64")]), _vm._v("  Information marketing: beyond e-books")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/74_ch65",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("65")]), _vm._v("  Five proven strategies for getting clients")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/75_ch66",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("66")]), _vm._v("  Consumers love freebies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/76_ch67",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("67")]), _vm._v("  Motivating consumers with the 4 Ds of marketing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/77_ch68",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("68")]), _vm._v("  Why you can’t do everything")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/78_ch69",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("69")]), _vm._v("  Seven tips for getting your book published")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/79_ch70",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("70")]), _vm._v("  Do this before e-mailing affiliate offers to your list")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/80_ch71",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("71")]), _vm._v("  How to cut down on refund requests")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/81_ch72",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("72")]), _vm._v("  How to treat your best customers … and your worst")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/82_ch73",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("73")]), _vm._v("  Get rich in your niche")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/83_ch74",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("74")]), _vm._v("  There’s no substitute for real-world experience")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/84_ch75",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("75")]), _vm._v("  Time to stop reading and start doing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/85_ch76",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("76")]), _vm._v("  Do you burn with the envy of others?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/86_ch77",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("77")]), _vm._v("  Write like they talk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/87_ch78",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("78")]), _vm._v("  The 3 most important skills for Internet marketing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/88_ch79",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("79")]), _vm._v("  Building your “swipe file”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/89_ch80",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("80")]), _vm._v("  Crafting your elevator pitch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/90_ch81",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("81")]), _vm._v("  The Awful Truth About Content Marketing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _c('span', {
    attrs: {
      "href": "#/91_ch82",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("82")]), _vm._v("  How to Get Out of a Slump")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/92_ch83",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("83")]), _vm._v("  Action vs. Motivation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/93_ch84",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("84")]), _vm._v("  The Virtue of Modesty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/94_ch85",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("85")]), _vm._v("  What It Really Takes to Become a Guru")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/95_ch86",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("86")]), _vm._v("  What You Have to be Good At to Succeed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/96_ch87",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("87")]), _vm._v("  Five Mistake I Wish I Had Avoided")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/97_con",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3a"
  }, [_c('span', {
    attrs: {
      "href": "#/98_4bon",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Bonus Reports (a $116 Value) — Yours FREE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3a"
  }, [_c('span', {
    attrs: {
      "href": "#/99_about",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f266866","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/07_toc.vue
// module id = 75
// module chunks = 0